// extracted by mini-css-extract-plugin
export default {"status":"status_status__URO5p","pending":"status_pending__-Qrik","completed":"status_completed__kSNPY","error":"status_error__VX3yT"};